var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-app-bar[data-v-f508a662]{border:solid transparent;border-width:26px 28px 29px;border-image-source:url(" + escape(require("../../images/app_bar.png")) + ");border-image-repeat:repeat;border-image-slice:26 28 29;background:url(" + escape(require("../../images/app_bar_background.png")) + ") repeat content-box;color:#b7b0a9;margin:0 4px;height:84px !important\n}\n", ""]);

// exports
